import { BUDGET_PRICE_POINT_RATIO } from '../../constants/buyerSettings'

export const getPricePoint = (affordability, maxBudget) => {
  if (affordability) {
    return affordability
  }

  if (maxBudget) {
    return maxBudget / BUDGET_PRICE_POINT_RATIO
  }

  return null
}

export const getMaxBudget = (affordability, maxBudget) => {
  if (maxBudget) {
    return maxBudget
  }

  if (affordability) {
    return BUDGET_PRICE_POINT_RATIO * affordability
  }

  return null
}
